import { theme } from "../utils/theme";

export default function MyText(props) {
    const textStyle = {
        fontSize: props.size || "1rem",
        fontWeight: props.weight || 400,
        // fontSize: props.size || "1rem",
        fontFamily: props.family || "inter",
        color: props.color || theme.text,
        ...props.style
    };
    return <div className={props.className} style={textStyle}>{props.children}</div>;
}